<template>
  <v-row>
    <v-col cols="12" v-if="testMode">
      <v-alert class="" border="top" type="warning" :icon="false" text dense prominent>
        <v-row>
          <v-col cols="6" class="pb-1">
            <span class="d-block brown--text darken-4 body-2">Tarjeta de prueba</span>
            <v-tooltip right transition="scale-transition">
              <template v-slot:activator="{on}">
                <v-btn v-on="on" @click="toClipboard(gateway.testMode.card.number)" text color="deep-orange darken-4" :ripple="false">{{gateway.testMode.card.number}}</v-btn>
              </template>
              <span>Copiar</span>
            </v-tooltip>
          </v-col>
          <v-col cols="3" class="pb-1">
            <span class="d-block body-2 brown--text darken-4">Vencimiento</span>
            <span class="d-block py-1 body-2 font-weight-medium deep-orange--text text--darken-4">12 / 26</span>
          </v-col>
          <v-col cols="3" class="pb-1">
            <span class="d-block body-2 brown--text darken-4">CVC</span>
            <span class="d-block py-1 body-2 font-weight-medium deep-orange--text text--darken-4">123</span>
          </v-col>
        </v-row>
      </v-alert>
    </v-col>
    <v-col cols="12">
      <v-sheet class="px-2 py-3" outlined rounded>
        <div id="stripe-element"></div>
      </v-sheet>
    </v-col>
  </v-row>
</template>
<script>
import { mapState } from 'vuex'
import { loadStripe } from '@stripe/stripe-js/dist/pure.esm.js'

import GatewayViewMixin from '../mixins/GatewayViewMixin'

export default {
  name: 'p-gateway-stripe',
  mixins: [
    GatewayViewMixin
  ],
  data: () => ({
    card: null,
    element: null,
    elements: null,
    gatewayError: '',
    options: {
      card: {
        hidePostalCode: true,
        style: {
          base: { color: '#525F7F' }
        }
      },
      elements: {
        locale: 'es'
      }
    },
    stripe: null
  }),
  computed: mapState({
    customer: state => state.apps.customersDetail,
    source: state => state.apps.sourcesDetail
  }),
  mounted () {
    const publicKey = this.testMode ? this.gateway.testMode.publicKey : this.gateway.credentials.publicKey
    loadStripe(publicKey)
    .then((s) => {
      this.stripe = s
      this.elements = this.stripe.elements(this.options.elements)
      this.element = this.elements.create('card', this.options.card)
      this.element.mount('#stripe-element')
    })
  },
  methods: {
    async send () {
      try {
        const t = await this.stripe.createToken(this.element)
        const token = t.token.id
        this.$emit('tokenized', token)
        return token
      } catch (e) {
        if (e.message) {
          this.$emit('error', e.message)
        }
        return null
      }
    }
  }
}
</script>